import type { EtatDeSynchronisation } from '../persistence/syncing-adapter.js';
import { T } from '../textes-interface.js';

/**
 * L'état de la sauvegarde, en petit et en permanence.
 *
 * Discret tant que tout va bien, visible dès que quelque chose cloche : un îlot
 * doit pouvoir constater lui-même que son travail est enregistré, sans qu'un
 * bandeau lui coupe l'écran en deux.
 */
export function IndicateurDeSauvegarde({ etat }: { etat: EtatDeSynchronisation }) {
  const apparence = {
    synchronise: { icone: '✓', texte: T.sauvegarde.synchronise, classe: 'text-emerald-700' },
    en_attente: { icone: '⋯', texte: T.sauvegarde.enAttente, classe: 'text-slate-500' },
    hors_ligne: { icone: '⚠', texte: T.sauvegarde.horsLigne, classe: 'text-amber-700' },
    conflit: { icone: '⚠', texte: T.sauvegarde.conflit, classe: 'text-rose-700' },
  }[etat];

  return (
    <p
      aria-live="polite"
      className={`flex items-center gap-1 text-sm font-medium ${apparence.classe}`}
    >
      <span aria-hidden="true">{apparence.icone}</span>
      <span>{apparence.texte}</span>
    </p>
  );
}
